<template lang="pug">
	.invoices-log
		.log-button(@click="() => showLog()", title="Show history")
			i.fas.fa-list-alt
		Popup(v-if="popupVisible", :popupVisible="popupVisible", :width="640", :height="480")
			.invoices-log
				ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => 10 /* r.TotalNumberOfRecords*/", :getItems="(r) => prepareData(r/*.Results*/)", :getData="loadData",
					:columns="columns",
					:showColumnHeaders="false"
				)
					template(slot="left-actions")
						.flex-row.space-large.align-center
							.font-large {{$tCaption('History')}}
					template(v-slot:operation-template="{ data }")
						.flex-col.log-operation
							.flex-row.justify
								.date {{formatDate(data.Timestamp, 'LLL')}}
								.actor {{data.AgencyStatusChanged ? 'Agency action' : 'Station owner action'}}
							.operation {{data.AgencyStatusChanged ? agencyStatuses[data.NewAgencyStatus] : ownerStatuses[data.NewOwnerStatus]}}
							.invoice.flex-row.space(v-if="uploadingId")
								span {{$tCaption('Invoice')}} {{`#${data.InvoiceNumber}, ${formatDate(data.InvoiceDate)}`}}
			template(slot="actions-right")
				DxButton(text="Close", @click="popupVisible = false")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import Loader from 'app-core/Loader.vue';
	import moment from 'moment';

	export default {
		translationCategory: 'invoice.InvoicesLog',
		name: 'agency-invoices-list',
		components: {
			ListView, DxButton, Loader, Popup
		},
		props: ['uploadingId', 'recordCode'],
		data() {
			return {
				agencyStatuses: [() => this.$tCaption('New'), () => this.$tCaption('Viewed'), () => this.$tCaption('Downloaded')],
				ownerStatuses: [() => this.$tCaption('New'), () => this.$tCaption('Pending validation'), () => this.$tCaption('Validated')],
				columns: [
					{ dataField: 'Operation', caption: () => this.$tCaption('Operation'), cellTemplate: 'operation-template' }
				],
				popupVisible: false
			};
		},
		computed: {

		},
		mounted() {
			if (__DEBUG__)
				window.invoiceLog = this;
		},
		methods: {
			formatDate(date, format) {
				return moment(date).format(format || 'L');
			},
			prepareData(data) {
				return (data || []).map(f => ({
					...f,
					AgencyStatusName: this.agencyStatuses[f.AgencyStatus],
				}));
			},
			loadData(pageIndex, limit, opts) {
				return this.$Data.getInvoicesLog(this.uploadingId, this.recordCode, pageIndex, limit, opts);
			},
			showLog() {
				this.popupVisible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.popupVisible = true;
				})
			}
		}
	};
</script>
<style lang='scss'>
	.invoices-log {
		@import "main/themes/generated/variables.base.scss";

		> .log-button {
			color: #bdbdbd;
			font-size: 16px;
			cursor: pointer;

			&:hover {
				color: $base-accent;
			}
		}

		.log-operation {
			.operation {
				font-weight: 800;
			}

			.date {
				font-size: 0.8em;
			}

			.actor {
				color: #bbb;
			}
		}
	}
</style>
